<!-- 收入 -->
<template>
  <div>
    <div class="income" :style="{ '--bacg': bacg, '--border': border }">
      <div class="leftLine1">
        <p class="p1">订单状态</p>
        <div class="line"></div>
        <div class="rightBox">
          <div class="left">
            <el-select class="select1" style="width: 2.1rem; margin-right: 0.1rem" size="small" v-model="value"
              placeholder="请选择">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <el-button @click="current = '已经关闭订单'" class="btns1" :class="current === '已经关闭订单' ? 'active' : ''"
              size="small" plain>已经关闭订单</el-button>
          </div>
          <div class="center">
            <p class="p1">订单状态</p>
            <div class="line"></div>
            <el-button @click="current1 = '已入账'" style="margin-right: 0.1rem" class="btns1"
              :class="current1 === '已入账' ? 'active' : ''" size="small" plain>已经关闭订单</el-button>
            <el-button @click="current1 = '待入账'" class="btns1" :class="current1 === '待入账' ? 'active' : ''" size="small"
              plain>已经关闭订单</el-button>
          </div>
          <div class="right">
            <p>符合条件共：</p>
            <div class="rightBlock">
              <p>0</p>
              <p>订单</p>
            </div>
            <div class="rightBlock">
              <p>0</p>
              <p>订单</p>
            </div>
            <div class="rightBlock">
              <p>0¥</p>
              <p>订单</p>
            </div>
            <p class="p3">清空筛选条件</p>
          </div>
        </div>
      </div>
      <div class="leftLine1">
        <p class="p1">查询结果</p>
        <div style="height: 1rem" class="line"></div>
        <div class="rightBox1">
          <div style="display: flex; align-items: center; margin-bottom: 0.2rem">
            <el-select class="select1" style="width: 1.4rem; margin-right: 0.1rem" size="small" v-model="value"
              placeholder="请选择">
              <el-option v-for="item in options1" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <el-input size="small" style="width: 1rem; margin-right: 0.1rem" placeholder="订单编号"></el-input>
            <el-input size="small" style="width: 1rem; margin-right: 0.1rem" placeholder="团号"></el-input>
            <el-input size="small" style="width: 1rem; margin-right: 0.1rem" placeholder="C端达人"></el-input>
            <el-input size="small" style="width: 1rem; margin-right: 0.1rem" placeholder="新客"></el-input>
            <el-input size="small" style="width: 1rem; margin-right: 0.1rem" placeholder="用户名称"></el-input>
            <el-input size="small" style="width: 1.2rem; margin-right: 0.1rem" placeholder="下单企业名称"></el-input>
            <el-input size="small" style="width: 1.2rem; margin-right: 0.1rem" placeholder="下单用户账号"></el-input>
            <el-input size="small" style="width: 1rem; margin-right: 0.1rem" placeholder="分销账号"></el-input>
            <el-select class="select1" style="width: 1.2rem; margin-right: 0.1rem" size="small" v-model="value"
              placeholder="支付方式">
              <el-option v-for="item in options2" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div style="display: flex; align-items: center; overflow: hidden">
            <el-input size="small" style="width: 1.4rem; margin-right: 0.1rem" placeholder="支付交易单号"></el-input>
            <el-date-picker size="small" style="margin-right: 0.1rem; width: 140px" v-model="value" type="date"
              placeholder="选择下单日期">
            </el-date-picker>
            <el-date-picker style="margin-right: 0.1rem; width: 140px" size="small" v-model="value" type="date"
              placeholder="选择付款日期">
            </el-date-picker>
            <p>金额：</p>
            <el-radio-group>
              <el-radio :label="3">
                <span style="margin-right: 5px">大于等于</span>
                <el-input size="small" style="width: 1rem; margin-right: 5px" placeholder="请输金额"></el-input>
                <span>¥</span>
              </el-radio>
              <el-radio :label="9">
                <span style="margin-right: 5px">小于等于</span>
                <el-input size="small" style="width: 1rem; margin-right: 5px" placeholder="请输金额"></el-input>
                <span>¥</span>
              </el-radio>
              <el-radio :label="6">
                <el-input size="small" style="width: 1rem; margin-right: 5px" placeholder="请输金额"></el-input>
                <span>¥</span>
                <span style="margin-right: 0.1rem">至</span>
                <el-input size="small" style="width: 1rem; margin-right: 5px" placeholder="请输金额"></el-input>
                <span>¥</span>
              </el-radio>
            </el-radio-group>
          </div>
        </div>
      </div>
    </div>
    <footer class="footer">
      <div class="footTitle">
        <div class="footTitleLeft">
          <p class="p1">客户下单及利润列表（我的佣金）</p>
          <!-- <div class="div-St">
            <p class="p2"><span>0</span> ¥</p>
            <p>预计利润</p>
          </div>
          <div class="div-St">
            <p class="p2"><span>0</span> ¥</p>
            <p>实际利润</p>
          </div>
          <div class="div-St">
            <p class="p2"><span>0</span> ¥</p>
            <p>目前可结算利润</p>
          </div> -->
        </div>
        <!-- <div class="footTitleRight">
          <el-button size="small" class="btns3" style="margin-right: 0.1rem">开发票</el-button>
          <el-button size="small" class="btns3" style="margin-right: 0.1rem">开发票</el-button>
          <el-button size="small" class="btns3">导出</el-button>
        </div> -->
      </div>
      <div style="border: 1px solid #ebeef5">
        <el-table v-loading="loading" :header-cell-style="{
          backgroundColor: '#FDEFE7',
          color: '#000000',
        }" ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%"
          @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column fixed="left"  width="150" prop="orderChildrenId" align="center" label="订单编号"> </el-table-column>
          <el-table-column width="150" align="center" label="下单时间">
            <template slot-scope="scope">
              {{ scope.row.orderCreateTime | dateFormatHms }}
            </template>
          </el-table-column>
          <el-table-column prop="customType" align="center" width="200" label="下单用户类型">
          </el-table-column>
          <el-table-column prop="nameOfSuperiorCustomer" align="center" width="190" label="下单账号昵称">
          </el-table-column>
          <el-table-column prop="orderStatusStr" align="center" label="订单状态"> </el-table-column>
          <!-- <el-table-column align="center" width="300" label="客户留言">
          </el-table-column> -->
          <el-table-column align="center" label="商品金额">
            <template slot-scope="scope">
              {{ scope.row.orderPrice }}{{ scope.row.currency }}
            </template>
          </el-table-column>
          <el-table-column align="center" width="200" label="预计利润">
            <template slot-scope="scope">
              {{ scope.row.estimatedProfit }}{{ scope.row.currency }}
            </template>
          </el-table-column>
          <el-table-column align="center" label="实际利润">
            <template slot-scope="scope">
              {{ scope.row.actualProfit }}{{ scope.row.currency }}
            </template>
          </el-table-column>
          <!-- <el-table-column align="center" label="操作"> </el-table-column> -->
        </el-table>
      </div>
      <Pagination :currentPage="init.page" :pageSizes="pageSizes" :parentPageSize="10" :totalNumber="AllpagesNum"
        @loadTable='loadTable'></Pagination>
    </footer>
  </div>
</template>

<script>
import Pagination from "@/components/Pagination.vue";
import OrderApi from '@/components/Api/order'

export default {
  components: {
    Pagination,
  },
  data() {
    return {
      bacg: "#F3E2D5",
      border: "#F3E2D5",
      tableData: [],
      value: "",
      current: "",
      current1: "",
      init: {
        "page": 1,
        "q": {

        },
        "size": 10
      },
      loading: false,
      AllpagesNum: 0,
      pageSizes: [10, 20, 25, 30],
      options: [
        {
          value: "1",
          label: "待付款",
        },
        {
          value: "2",
          label: "已付款 待操作",
        },
        {
          value: "3",
          label: "已关闭",
        },
        {
          value: "4",
          label: "已关闭（恶意订单关闭）",
        },
        {
          value: "5",
          label: "正常关闭",
        },
        {
          value: "6",
          label: "申请关闭",
        },
        {
          value: "7",
          label: "操作中订单",
        },
      ],
      options1: [
        {
          value: "1",
          label: "所有订单来源",
        },
        {
          value: "2",
          label: "PC端订单",
        },
        {
          value: "3",
          label: "小程序订单",
        },
      ],
      options2: [
        {
          value: "1",
          label: "微信",
        },
        {
          value: "2",
          label: "支付宝",
        },
        {
          value: "3",
          label: "积分",
        },
      ],
    };
  },
  computed: {},
  watch: {},
  methods: {
    handleSelectionChange() { },
    //客户下单及利润列表
    orderProfitSharing() {
      this.loading = true
      new OrderApi("order")
        .orderProfitSharing(this.init)
        .then((res) => {
          if (res.status == 200) {
            this.tableData = res.data.records
            this.AllpagesNum = res.data.total
            this.loading = false
          } else {
            this.$message.error({ message: res.statusText });
          }
        });
    },
    loadTable(page, size) {
      this.init.size = size
      this.init.page = page
      this.loading = true
      this.orderProfitSharing()
    },
  },
  created() { },
  mounted() {
    this.orderProfitSharing()
  },
};
</script>
<style lang="scss" scoped>
.active {
  background-color: #dc6d33 !important;
  color: #fff !important;
}

.income {
  .leftLine1 {
    display: flex;
    align-items: center;
    margin-bottom: 0.2rem;

    .p1 {
      color: #db6e33;
      font-size: 0.12rem;
      font-family: SourceHanSansSC-bold;
      font-weight: bold;
      width: 0.8rem;
      text-align: right;
    }

    .line {
      height: 0.3rem;
      width: 1px;
      border-right: 1px solid var(--color);
      margin: 0 0.1rem;
    }

    .btns {
      background-color: #f7e1d3;
      color: #db6e33;
    }

    .btns1 {
      background-color: #fff;
      color: #db6e33;
      border: 1px solid #db6e33;
    }

    .rightBox {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .left {
        display: flex;
        align-items: center;
      }

      .center {
        display: flex;
        align-items: center;
      }

      .right {
        height: 0.5rem;
        width: 5rem;
        border: 1px solid #db6e33;
        display: flex;
        align-items: center;
        padding: 0.1rem;
        justify-content: space-between;
        font-size: 0.12rem;

        .rightBlock {
          display: flex;
          align-items: center;
          flex-direction: column;
        }

        .p3 {
          color: #db6e33;
          cursor: pointer;
        }
      }
    }
  }
}

.footer {
  .footTitle {
    height: 0.5rem;
    border: 1px solid #ebeef5;
    padding: 0 0.4rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: none;

    .footTitleLeft {
      display: flex;
      align-items: center;

      .p1 {
        margin-right: 0.2rem;
        font-size: 0.16rem;
        font-weight: bold;
        color: #000;
      }

      .div-St {
        display: flex;
        align-items: center;
        flex-direction: column;
        margin-right: 0.2rem;

        p {
          font-size: 0.12rem;
        }

        .p2 {
          span {
            color: red;
            font-size: 0.14rem;
          }
        }
      }
    }

    .footTitleRight {
      .btns3 {
        background-color: #fff;
        color: #bbbbbb;
        border: 1px solid #bbbbbb;

        &:hover {
          background-color: #db6e33;
          color: #fff;
          border-color: #db6e33;
        }
      }
    }
  }
}
</style>
